import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ParcelService } from '../../shared/services/parcel.service';
import { MessageService } from 'primeng/api';
import { PRIMENG_MODULES } from '../../shared/primeng-imports';

@Component({
  selector: 'app-export-barcodes',
  templateUrl: './export-barcodes.component.html',
  styleUrl: './export-barcodes.component.scss',
  standalone:true,
  imports:[...PRIMENG_MODULES]
})
export class ExportBarcodesComponent {
  @Input() visible: boolean = false;
  @Output() onClose = new EventEmitter()
  dateFrom: string = '';
  dateTo: string = '';
  disableFutureDate = new Date();
  disablePastDate: any;
  loading: boolean = false;

  constructor(
    private parcelService: ParcelService,
    private messageService: MessageService,
  ) {
    this.disableFutureDate.setDate(this.disableFutureDate.getDate());
  }

  onFromDateSelect(value: any) {
    this.disablePastDate = new Date(value);
    this.disablePastDate.setDate(value.getDate())
  }

  hideDialog() {
    this.onClose.emit();
    this.visible = false;
    this.dateFrom = '';
    this.dateTo = '';
  }

  onExport() {
    this.loading = true;
    const fileName = 'report' + '_' + this.formatDate(this.dateFrom) + '_' + this.formatDate(this.dateTo) + '.xlsx';
    let toDate = new Date(this.dateTo)
    toDate.setHours(23, 59, 59, 999);
    let fromDate = new Date(this.dateFrom)
    fromDate.setHours(0, 0, 0, 0)
    this.parcelService.exportBarcode({ "dateFrom": fromDate.getTime(), "dateTo": toDate.getTime() }).subscribe({
      next: (result) => {
        this.downloadExcel(result)
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Failed to export file',
          detail: err?.message || 'Something went wrong , Please try again'
        });
        this.loading = false;
      }
    }
    )

  }
  downloadExcel(result: any) {
    const fileName = 'report' + '_' + this.formatDate(this.dateFrom) + '_' + this.formatDate(this.dateTo) + '.xlsx';
    this.hideDialog();
    // Decode Base64
    const byteCharacters = atob(result);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create Excel Blob
    const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Trigger download
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    this.messageService.add({
      severity: 'success',
      summary: 'Export',
      detail: `${fileName} file Export Finished`
    });
    this.loading = false;
  }
  formatDate(dateInput: string | number | Date): string {
    const date = new Date(dateInput);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
